"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let DataViewerModal = class DataViewerModal extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "modal",
    };
    beforeCreate() {
    }
    headerText;
    onHeader_text(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("headerText");
    }
    content;
    onContent(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("content");
    }
    mode;
    onMode(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("mode");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    ux;
    b_7315092382398562_noHeader;
    b_8564662037462133_options;
    dataMembers = ['ux', 'b_7315092382398562_noHeader', 'b_8564662037462133_options'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ux: null,
                b_7315092382398562_noHeader: false,
                b_8564662037462133_options: {
                    lineNumbers: true,
                    matchBrackets: true,
                    continueComments: "Enter",
                },
            },
        };
    }
    get inputData() {
        if (this.loaded) {
            return this.mode === 'json'
                ? (_.isString(this.content) ? this.content : JSON.stringify(this.content, null, 2))
                : (this.mode === 'yaml'
                    ? this.$fn.toYamlString(this.content)
                    : this.content);
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.headerText || this.$fn.gettext("View Data"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_2398_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_2398 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_2398_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_2397 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_2398,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_2397],
        });
        return {
            act_7315092382398562_closeModal_2398,
            evh_7315092382398562_close_2397,
            evh_7315092382398562_close,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], DataViewerModal.prototype, "headerText", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('headerText'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], DataViewerModal.prototype, "onHeader_text", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], DataViewerModal.prototype, "content", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('content'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], DataViewerModal.prototype, "onContent", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], DataViewerModal.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('mode'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], DataViewerModal.prototype, "onMode", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], DataViewerModal.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], DataViewerModal.prototype, "onSize", null);
DataViewerModal = __decorate([
    (0, vue_property_decorator_1.Component)()
], DataViewerModal);
exports.default = DataViewerModal;
vue_property_decorator_1.Vue.component("DataViewerModal", DataViewerModal);
